import { render, staticRenderFns } from "./STableRatesComp.vue?vue&type=template&id=51cec164&"
import script from "./STableRatesComp.vue?vue&type=script&lang=js&"
export * from "./STableRatesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports